<script setup lang="ts">
  import { onMounted } from 'vue'
  import { Table } from '@logistiek-zonder-papier/lzp-library'
  import { createFlatBaseColumns } from '@/utils/table'
  import { useIopFormStore } from '@/store/iop-form.store.ts'

  const formStore = useIopFormStore()

  onMounted(async () => {
    await formStore.fetchAllIopFailures()
  })
</script>

<template>
  <div class="layout">
    <Table
      :rows="formStore.failures"
      :columns="
        createFlatBaseColumns(formStore.failures, [
          'lastModifiedDate',
          'createdBy',
          'createdByOrganisation',
          'lastModifiedBy',
          'extraOptions',
          'deleted',
          'syncindex',
          'owner',
        ])
      "
      row-key="id"
      :search="true"
      :pagination="true"
    >
    </Table>
  </div>
</template>

<style scoped>
  .layout {
    background: var(--colours-grey-1);
    display: flex;
    padding: var(--layout-layout-padding-top-app) var(--layout-layout-padding-top-app)
      var(--layout-layout-padding-bottom-app) var(--layout-layout-padding-bottom-app);
    flex-direction: column;
    gap: var(--layout-layout-spacing-app);
    flex: 1 0 0;
  }
</style>
